// Copyright (c) 2026 Query Health Inc. All rights reserved.
// Author: Shubham Dixit <shubham@quantinohealth.com>
// Licensed under a Commercial License. See LICENSE for terms.

interface LogoMarkProps {
  className?: string;
  'aria-hidden'?: boolean;
}

export function LogoMark({ className, 'aria-hidden': ariaHidden }: LogoMarkProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1253 846"
      className={className}
      aria-hidden={ariaHidden}
      aria-label={ariaHidden ? undefined : 'Query Health'}
      role={ariaHidden ? undefined : 'img'}
    >
      {/* Q mark — Primary Blue */}
      <path
        fill="#006EF9"
        d="M636 663c15,-21 27,-43 37,-67 18,-42 27,-87 27,-135 0,-49 -9,-94 -27,-136 -17,-42 -42,-78 -74,-109 -31,-32 -68,-56 -111,-73 -42,-17 -88,-26 -139,-26 -49,0 -95,9 -138,26 -42,17 -79,41 -111,73 -31,31 -56,67 -74,108 -17,42 -26,87 -26,136 0,48 9,93 27,135 18,42 43,78 74,110 32,31 69,56 112,73 43,18 89,27 138,27 46,0 89,-8 128,-23l-112 -113c-6,1 -12,1 -18,1 -29,0 -56,-5 -80,-15 -24,-10 -45,-24 -63,-43 -17,-19 -31,-41 -40,-66 -10,-26 -14,-55 -14,-86 0,-42 8,-79 25,-110 16,-31 39,-55 69,-72 29,-18 64,-26 103,-26 30,0 58,5 82,14 24,10 45,24 62,43 18,18 32,40 41,66 9,25 14,54 14,85 0,36 -6,68 -19,96l-106 -106 -86 85 111 112 100 99 100 100 86 -86 -98 -97z"
      />
      {/* Sparkle accents — Primary Teal */}
      <path
        fill="#02C7C3"
        d="M917 265c-9,80 -73,143 -152,152 -5,1 -8,5 -8,9l0 1c0,5 3,9 8,9 79,9 143,72 152,152 0,5 4,8 8,8l2 0c4,0 8,-3 8,-8 9,-80 73,-143 152,-152 5,0 8,-4 8,-9l0 -1c0,-4 -3,-8 -8,-9 -79,-9 -143,-72 -152,-152 0,-4 -4,-7 -8,-7l-2 0c-4,0 -8,3 -8,7zm90 -32c59,7 106,54 113,113 0,3 3,6 6,6l1 0c4,0 6,-3 7,-6 6,-59 54,-106 113,-113 3,0 6,-3 6,-7l0 0c0,-4 -3,-7 -6,-7 -59,-7 -107,-54 -113,-113 -1,-4 -3,-6 -7,-6l-1 0c-3,0 -6,2 -6,6 -7,59 -54,106 -113,113 -4,0 -6,3 -6,7l0 0c0,4 2,7 6,7zm-33 -75c5,-38 35,-68 73,-73 2,0 4,-2 4,-4l0 0c0,-2 -2,-4 -4,-5 -38,-4 -68,-34 -73,-72 0,-2 -2,-4 -4,-4l0 0c-3,0 -4,2 -5,4 -4,38 -34,68 -72,72 -3,1 -4,3 -4,5l0 0c0,2 1,4 4,4 38,5 68,35 72,73 1,2 2,4 5,4l0 0c2,0 4,-2 4,-4z"
      />
    </svg>
  );
}
